import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Table, TableHead, TableRow, TableCell, TableBody, Stack, Typography } from '@mui/material';
import { ButtonBasic } from '../../components/button/ButtonBasic.jsx';

/**
 * CafeAdminListModal
 *
 * Props:
 * @param {boolean} opened - 모달 열림 여부 [Required]
 * @param {function} onClose - 닫기 핸들러 [Required]
 * @param {Array<object>} cafes - 카페 리스트 [Required]
 * @param {function} onEdit - 편집 클릭(id 또는 객체) [Required]
 * @param {function} onDelete - 삭제 클릭(id) [Optional]
 */
export default function CafeAdminListModal({ opened, onClose, cafes = [], onEdit, onDelete }) {
  return (
    <Dialog open={opened} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>카페 목록/수정</DialogTitle>
      <DialogContent dividers>
        {cafes.length === 0 ? (
          <Stack sx={{ py: 2 }}>
            <Typography variant="body2" color="text.secondary">등록된 카페가 없습니다.</Typography>
          </Stack>
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ width: 180 }}>이름</TableCell>
                <TableCell sx={{ width: 260 }}>주소</TableCell>
                <TableCell>설명</TableCell>
                <TableCell sx={{ width: 160 }}>좌표</TableCell>
                <TableCell sx={{ width: 200 }}>링크</TableCell>
                <TableCell sx={{ width: 160 }} align="right">작업</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {cafes.map((c) => (
                <TableRow key={c.id} hover>
                  <TableCell>{c.name || '-'}</TableCell>
                  <TableCell sx={{ maxWidth: 320, whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }} title={c.address || ''}>{c.address || '-'}</TableCell>
                  <TableCell sx={{ maxWidth: 320, whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{c.description || '-'}</TableCell>
                  <TableCell>{typeof c.lat === 'number' && typeof c.lng === 'number' ? `${c.lat.toFixed(5)}, ${c.lng.toFixed(5)}` : '-'}</TableCell>
                  <TableCell>
                    <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
                      {c.threadsUrl ? <a href={c.threadsUrl} target="_blank" rel="noreferrer">threads</a> : null}
                      {c.cafeUrl ? <a href={c.cafeUrl} target="_blank" rel="noreferrer">site</a> : null}
                    </Stack>
                  </TableCell>
                  <TableCell align="right">
                    <Stack direction="row" spacing={1} justifyContent="flex-end">
                      <ButtonBasic size="xs" variant="text" onClick={() => onEdit && onEdit(c)}>수정</ButtonBasic>
                      {onDelete ? <ButtonBasic size="xs" variant="text" actionType="error" onClick={() => onDelete(c.id)}>삭제</ButtonBasic> : null}
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </DialogContent>
      <DialogActions>
        <ButtonBasic variant="text" onClick={onClose}>닫기</ButtonBasic>
      </DialogActions>
    </Dialog>
  );
}


